<!--<template>-->
<!--    <div id="page-container">-->
<!--        <main id="main-container">-->
<!--            <div class="bg-image" style="background-image: url('assets/media/photos/photo19@2x.jpg');">-->
<!--                <div class="row no-gutters bg-gd-aqua">-->
<!--                    <div class="hero-static col-md-6 d-flex align-items-center bg-white">-->
<!--                        <div class="p-3 w-100">-->
<!--                            <div class="text-center">-->
<!--                                <a class="link-fx text-primary font-w700 font-size-h1" href="/">-->
<!--                                    <span class="text-dark">Emali</span><span class="text-primary">fy</span>-->
<!--                                </a>-->
<!--                                <p class="font-w700 pr-8 pl-8 font-size-sm text-muted">Enter the email address you used to register with Emalify and we'll send you instructions to reset your password.</p>-->
<!--                            </div>-->
<!--                            <div class="row no-gutters justify-content-center">-->
<!--                                <div class="col-sm-8 col-xl-6">-->
<!--                                    <el-form :rules="rules" :model="form" ref="password-reminder">-->
<!--                                        <div class="form-group">-->
<!--                                            <el-form-item prop="email">-->
<!--                                                <el-input v-model="form.email"  placeholder="Your email address" suffix-icon="si si-envelope">-->
<!--                                                </el-input>-->
<!--                                            </el-form-item>-->
<!--                                        </div>-->
<!--                                        <div class="form-group text-center">-->
<!--                                            <button @click.prevent="resetPassword" class="btn btn-block btn-hero-lg btn-hero-primary">-->
<!--                                                <i class="fa fa-fw fa-envelope-open mr-1"></i> Send Instructions-->
<!--                                            </button>-->
<!--                                            <p class="mt-3 mb-0 d-lg-flex justify-content-lg-between">-->
<!--                                                <router-link class="btn btn-sm btn-light d-block d-lg-inline-block mb-1" to="/login">-->
<!--                                                    <i class="fa fa-sign-in-alt text-muted mr-1"></i> Sign In-->
<!--                                                </router-link>-->
<!--                                                <router-link class="btn btn-sm btn-light d-block d-lg-inline-block mb-1" to="/register">-->
<!--                                                    <i class="fa fa-plus text-muted mr-1"></i> New Account-->
<!--                                                </router-link>-->
<!--                                            </p>-->
<!--                                        </div>-->
<!--                                    </el-form>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="hero-static col-md-6 d-none d-md-flex align-items-md-center justify-content-md-center text-md-center">-->
<!--                        <div class="p-3">-->

<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </main>-->
<!--    </div>-->

<!--</template>-->

<script>
    import {axios} from '../../bootstrap';

    export default {
        name: "PasswordReminder",
        data() {
            return {
                resetting: false,
                form: {
                    email: '',
                    resetUrl: 'password/reset'
                }
            }
        },
        methods: {
            rollback() {
                this.$router.push("/login")
            },
            resetPassword() {
                this.resetting = true;
                axios.post('password/forgot', this.form).then(() => {
                    this.form.email = '';
                    this.$notify.success({
                        title: 'Password Reminder Sent',
                        message: 'Please check your mail for instructions on how to reset your password',
                        duration: 10000
                    })
                }).catch(error => {
                    if (error.response && error.response.status === 422) {
                        this.$notify.error({
                            title: error.response.data.message,
                            message: error.response.data.errors.email[0]
                        })
                    }
                }).finally(() => {
                    this.resetting = false;
                })
            }
        }
    }
</script>

<template>
    <div class="container-fluid">
        <div class="row">
            <div
                    class="verify-content d-flex align-items-center justify-content-center"
            >
                <div class="card block">
                    <div class="card-body block-content">
                        <div class="mb-3 p-2" align="center">
                            <img
                                    src="/images/login/resetPassword.png"
                                    class="img-fluid"
                                    style="width: 60%"
                                    div/>
                        </div>
                        <div class="mb-3 bg-white" align="center">
                            <h1 class="heading-info h-color">
                                Reset Your Password
                            </h1>
                            <span class="login-card-info">
                                Enter your email address and we will send you a
                                link to reset your password
                            </span>
                        </div>
                        <form class="user">
                            <div class="form-group mb-3">
                                <input
                                        required
                                        type="email"
                                        class="form-control"
                                        aria-describedby="emailHelp"
                                        v-model="form.email"
                                        placeholder="Enter Email Address..."
                                />
                            </div>
                            <div class="call-to-action d-flex justify-content-lg-between justify-content-between pb-2">
                                <el-button size="small" @click="rollback">
                                    Cancel
                                </el-button>
                                <el-button
                                        type="primary"
                                        size="small"
                                        icon="el-icon-connection"
                                        @click="resetPassword"
                                        :loading="resetting"
                                >
                                    Send Reset Link
                                </el-button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import "../../sass/custom/mixins";

    .container {
        min-width: 100vw;
    }

    .verify-content {
        min-height: 100vh;
        background: #fafbfc;
        min-width: 100vw;
    }

    .card {
        width: 24rem;
        @include for-phone-only() {
            margin-right: 1.5rem;
        }
    }

    .h-color {
        color: #2c3f58;
    }

    .heading-info {
        letter-spacing: 0;
        color: #2c3f58;
        opacity: 1;
        font-size: 20px;
        font-weight: bold;
    }

    .card-heading {
        text-align: left;
        letter-spacing: 0;
        color: #2c3f58;
        opacity: 1;
        font-size: 22px;
        font-weight: bold;
    }

    .form-input {
        background: #ffffff 0% 0% no-repeat padding-box;
        border: 1px solid #dce1e7;
        border-radius: 8px;
        opacity: 1;
        font-size: 14px;
    }

    .form-input:active:focus {
        background: #ffffff 0% 0% no-repeat padding-box;
        border: 1px solid #2985ef;
        border-radius: 8px;
        opacity: 1;
        font-size: 14px;
    }

    .login-p {
        text-align: left;
        letter-spacing: 0;
        color: #2c3f58;
        opacity: 1;
        font-weight: 300;
        font-size: 16px;
    }

    .fz-24 {
        font-size: 18px;
        font-weight: 800 !important;
    }

    .login-card-info {
        font-size: 12px;
        font-weight: 600;
        color: #778699;
    }

    .link {
        font: 14px/22px;
        letter-spacing: 0;
        color: #2985ef;
        opacity: 1;
    }

    label {
        text-align: left;
        font-size: 14px;
        font-weight: bold;
        letter-spacing: 0;
        color: #254050;
        opacity: 1;
    }

    .login-btn {
        background: #2985ef 0% 0% no-repeat padding-box;
        border-color: #2985ef;
        border-radius: 8px;
        width: 40px;
        opacity: 1;
        text-align: center;
        font-size: 14px;
        letter-spacing: 0;
        color: #ffffff;
    }

    .login-btn:hover {
        background-color: #ffffff;
        color: #2985ef;
        border-color: #2985ef;
        border-radius: 8px;
        opacity: 1;
        text-align: center;
        font-size: 14px;
        letter-spacing: 0;
    }
</style>
